import React, { useEffect, useState } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import "./PaymentStatus.css";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getPdf, getStudentDetailsByAdmission, resetStudentSliceState, updateOrderStatus } from "../../redux/features/student/studentSlice";
import { resetPaymentStatusSliceState } from "../../redux/features/payment/payment.order.slice";
import { Spinner } from 'react-bootstrap'
import { MdFileDownload } from 'react-icons/md'
import {BiArrowBack} from 'react-icons/bi'
import Logo from '../../assets/images/svbk_logo.png'
import { useNavigate } from 'react-router-dom';
import * as constants from "../../config/config"

const PaymentStatus = () => {

  const dispatch = useDispatch()

  const { admId, academicYear } = useParams()

  const [theArray, setTheArray] = useState([]);

  const orderDetails = useSelector(state => state.createOrder)

  const updatedDetails = orderDetails.updatePaymentDetails

  const userDetails = useSelector(state => state.student)

  const details = userDetails.getStudentDetailsByAdmissionDetails

  const payeeDetails = details?.data

  const pdfDetails = useSelector(state => state.student.getPdfDetails)

  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getStudentDetailsByAdmission({
      admission: admId,
      academicYear
    }))
  }, [])

  useEffect(() => {
    if (details.status === "succeeded" && payeeDetails) {
      payeeDetails?.termFee?.map((eachItem) => {
        if (Object.keys(eachItem)[0] === payeeDetails?.receipt) {
          setTheArray(eachItem[payeeDetails?.receipt])
        }
      })
    }
    dispatch(updateOrderStatus("idle"))
  }, [details.status])

  useEffect(() => {
    if (updatedDetails.status === "succeeded") {
      dispatch(resetStudentSliceState())
      dispatch(resetPaymentStatusSliceState())
      window.location.reload(true)
    }
  }, [updatedDetails.status])

  useEffect(() => {
    if(pdfDetails.status === "succeeded"){
      console.log("padfdetails.url",typeof(pdfDetails.url),pdfDetails.url)
      window.open(pdfDetails.url)
    }
  }, [pdfDetails.status,pdfDetails.url])

  const downloadPdf = async () => {
    dispatch(getPdf({admissionId:admId, academicYear, term: payeeDetails?.receipt}))

    // const input = document.getElementById("App")

    // html2canvas(input, { logging: true, letterRendering: 1, useCORS: true }).then(canvas => {
    //   const imgWidth = 208;
    //   const imgHeight = canvas.height * imgWidth / canvas.width
    //   const imgData = canvas.toDataURL("img/png")
    //   const pdf = new jsPDF('p', 'mm', 'a4');
    //   pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight)
    //   pdf.save(`receipt ${payeeDetails.admissionNumber}`)
    // })
  }

  const fullDate = new Date(theArray.date);
  const date = ("0" + fullDate.getDate()).slice(-2);
  const month = ("0" + (fullDate.getMonth() + 1)).slice(-2);
  const year = fullDate.getFullYear();

  console.log("the array",theArray)

  return (
    <>
    {(details.status === "loading" || pdfDetails.status === "loading" || theArray.length === 0) ?
      <div style={{ minHeight: '80vh' }} className='d-flex justify-content-center align-items-center'>
        <Spinner animation="border" role="status"></Spinner>
      </div>
      :

      <div id="App">
            <div className="d-flex justify-content-between p-2">
              <button className="btn btn-primary" onClick={() => {navigate("/admission",{replace : true});}}> <BiArrowBack /> Home</button>
              <div className="d-flex justify-content-end mt-2">
              <button type="button" onClick={downloadPdf} class="btn btn-link">Download Receipt</button>
                
                {/* <MdFileDownload className="" onClick={downloadPdf} size={30} style={{ cursor: "pointer" }} title="Download" /> */}
              </div>
            </div>

            <div className="d-flex justify-content-center mb-4">
                <div className="d-flex flex-column align-items-center" >
                    <img src={Logo} className="mb-2" style={{width:"70px"}}/>
                    <h3 className='payment-status-heading'>{payeeDetails.receipt}</h3>
                    <h3 className='payment-status-heading'>{theArray?.paymentStatus === "Paid" ? "Payment Successful" : "Oops! Your transaction has Failed"}</h3>
                </div>
            </div>

            <div className="payment-details-container">

                <div className=''>

                    <div className="d-flex align-items-center p-2" >
                        <h3 className="payment-status-heading" >Payment Status :</h3>
                        {/* <span className="">:</span> */}
                        <span className="value">&nbsp;{theArray.paymentStatus}</span>
                    </div>
                    <div className="d-flex align-items-center p-2" >
                        <h3 className="payment-status-heading" >Payment Date :</h3>
                        {/* <span className="">:</span> */}
                        <span className="value">&nbsp;{`${date}-${month}-${year}`}</span>
                    </div>

                </div>

                <div className=''>
                  
                    <div className="d-flex align-items-center p-2">
                        <h3 className="payment-status-heading">Order ID :</h3>
                        <span className="value">&nbsp;{theArray.orderId}</span>
                    </div>

                    <div className='d-flex align-items-center p-2'>
                        <h3 className="payment-status-heading">Transaction Id :</h3>
                        {/* <span className=''>:</span> */}
                        <span className="value">&nbsp;{theArray.transactionId}</span>
                    </div>

                    <div className='p-2'>
                        <h3 className='payment-status-heading amount'>Amount : Rs {theArray.paidAmount ? theArray.paidAmount : theArray.amount}/-</h3>
                    </div>

                </div>

            </div>

            <div className='payer-table-details-web'>
                <div className="d-flex flex-column align-items-center p-2">
                    <div className="w-50">
                    <h2 className="pt-3 pb-3 mb-0" style={{fontSize:"18px"}}>Payer Details</h2>
                    <table className="w-100">
                        <thead></thead>
                        <tbody>
                        <tr style={{ backgroundColor: "#f2f2f4" }}>
                            <th>Name</th>
                            <td>{payeeDetails.name}</td>
                        </tr>
                        <tr>
                            <th>Admission</th>
                            <td>{payeeDetails.admissionNumber}</td>
                        </tr>
                        <tr style={{ backgroundColor: "#f2f2f4" }}>
                            <th >class</th>
                            <td>{payeeDetails.class}</td>
                        </tr>
                        <tr>
                            <th>Section</th>
                            <td>{payeeDetails.section}</td>
                        </tr>
                        <tr style={{ backgroundColor: "#f2f2f4" }}>
                            <th>Roll No</th>
                            <td>{payeeDetails.rollNo}</td>
                        </tr>
                        </tbody>
                    </table>

                    <h2 className="pt-3 pb-3 mt-3 mb-0" style={{fontSize:"18px"}}>Payment Description</h2>
                    <table className="w-100">
                        <thead></thead>
                        <tbody>
                        <tr style={{ backgroundColor: "#f2f2f4" }}>
                            <th>Fee&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th>
                            <td>Rs.{theArray.paidAmount ? theArray.paidAmount : theArray.amount}</td>
                        </tr>
                        </tbody>
                    </table>
                    
                    {/* {theArray.paymentStatus === "Paid" ? null :
                        <div className=" d-flex justify-content-center">
                        <button className="TryAgainButton">Try Again</button>
                        </div>
                    } */}
                    </div>

                </div>
            </div>

            <div className='payer-table-details-mobile p-2'>
                <h5 className="mt-3">Payer Details :</h5>
                <div className="payer-details-card p-2">
                    <div className="payer-details-field-container">
                        <p className="payer-details-field-key">Name :</p>
                        <p className="payer-details-field-value">{payeeDetails.name}</p>
                    </div>
                    <div className="payer-details-field-container">
                        <p className="payer-details-field-key">Admission :</p>
                        <p className="payer-details-field-value">{payeeDetails.admissionNumber}</p>
                    </div>
                    <div className="payer-details-field-container">
                        <p className="payer-details-field-key">class :</p>
                        <p className="payer-details-field-value">{payeeDetails.class}</p>
                    </div>
                    <div className="payer-details-field-container">
                        <p className="payer-details-field-key">Section :</p>
                        <p className="payer-details-field-value">{payeeDetails.section}</p>
                    </div>
                    <div className="payer-details-field-container">
                        <p className="payer-details-field-key">Roll No :</p>
                        <p className="payer-details-field-value">{payeeDetails.rollNo}</p>
                    </div>
                </div>

                <h5 className="mt-3">Payment Description :</h5>
                <div className="payer-details-card p-2">
                    <div className="payer-details-field-container">
                        <p className="payer-details-field-key">Fee :</p>
                        <p className="payer-details-field-value">{theArray.amount}</p>
                    </div>
                </div>
            </div>

            <hr />

          <div className='p-2'>
  
            <div className="d-flex justify-content-between  p-2" >
                <span className="school-details-heading" >Email &nbsp;&nbsp;&nbsp;</span>
                <span>&nbsp;:&nbsp;</span>
                <span className="value w-75">{constants.email}</span>
            </div>
            <div className="d-flex justify-content-between p-2" >
                <span className="school-details-heading" >Address </span>
                <span>&nbsp;:&nbsp;</span>
                <span className="value w-75">{constants.address}</span>
            </div>
            <div className="d-flex justify-content-between p-2" >
                <span className="school-details-heading" >Phone&nbsp;&nbsp;&nbsp;</span>
                <span>&nbsp;:&nbsp;</span>
                <span className="value w-75">{constants.phoneNumber}</span>
            </div>
          </div> 
          <p className="payment-footer m-0">In case of any issues please call us at {constants.phoneNumber} or drop an email at {constants.email}</p>
      </div >

    }
  </>
  )
}

export default PaymentStatus